
import {PAGINATION_NUM_ENTRIES_LIST} from 'Utils/constants';
import { Form, Col, Row} from 'react-bootstrap';


const DatatableNumEntriesField = ({currentLength, handlePageRowsChange, controlId}) => {

    return (
        <Form.Group as={Row} controlId={controlId!=null ? controlId + "form_rows" : "form_rows"} >
            <Col lg="auto" className="d-flex align-items-center">
                <Form.Label className="tableMutedText">Show</Form.Label>
                <Form.Select
                    name="rows"
                    onChange={handlePageRowsChange}
                    className="ms-2 me-2 "
                >
                    {
                        PAGINATION_NUM_ENTRIES_LIST.map((v) => 
                            <option key={"rowsOption_" + v} value={v} title={"Display " + v + "rows."} selected={currentLength == v ? true : false}>{v}</option>
                        )
                    }
                </Form.Select>
                <Form.Text className="tableMutedText">entries</Form.Text>
            </Col>
        </Form.Group>
    )
  }
  
  export default DatatableNumEntriesField;